import { useEffect, useState } from 'react';

/**
 * Secondi residui fino a un deadline ISO, aggiornati ogni secondo e
 * clampati a 0. Riusato dagli overlay di pausa (credito esaurito e pausa
 * manuale) per il countdown visivo.
 */
export function useCountdown(deadlineIso: string): number {
  const [remaining, setRemaining] = useState(() =>
    Math.max(0, Math.ceil((new Date(deadlineIso).getTime() - Date.now()) / 1000))
  );

  useEffect(() => {
    const tick = () =>
      setRemaining(Math.max(0, Math.ceil((new Date(deadlineIso).getTime() - Date.now()) / 1000)));
    tick();
    const id = setInterval(tick, 1000);
    return () => clearInterval(id);
  }, [deadlineIso]);

  return remaining;
}
